export const baseUrl = "http://3.111.100.30:6001";

// export const baseUrl = "https://3.110.50.88:6001";

// export const baseUrl = "http://hruthiaitechhub.com";

// export const baseUrl = "http://localhost:6001";
